import { Injectable, ErrorHandler } from '@angular/core';

@Injectable()
export class ErrorHandlerService extends ErrorHandler {

    constructor() {
        super();
    }

    handleError(error: Error) {
        console.error('An error occurred:', error);
    }
}